import { ItemConfig } from '../types';

type DynamicConfig = {
    key: string,
    type: string,
    show: boolean,
    required: boolean,
    enabled: boolean
};

/**
 * 动态校验规则
 * @param {boolean} required 是否必填
 * @param validators 预设校验规则
 * @param type 字段类型
 */
const dynamicValidators = (required: boolean, validators: any, type: string) =>
    [required
        ? ({
            selectInput: 'required.selectInput',
            complexAddress: 'required.complexAddress',
            address: 'required.address',
            dynamicSelect: 'required.dynamicSelect',
            areaSelectInput: 'required.areaSelectInput',
            encryptUploadMulti: 'required.array',
            upload: 'required.array',
            phone: 'required.array',
            certificate: 'required.array',
            cascade: 'required.array',
            checkBoxInput: 'required.checkBoxInput',
    } as any)[type] || 'required'
        : false
    ].concat((validators || []))
        .filter((validator: any) => !!validator);

/**
 * 动态表单配置
 * @param itemsConfig
 * @param dynamicConfig
 * @param defaultHandler
 * @param defaultValues
 * @param editable
 */
export default (itemsConfig: { [key: string]: ItemConfig } = {}, dynamicConfig: Array<DynamicConfig>, defaultHandler?: Function, defaultValues: { [key: string]: any } = {}, editable?: boolean) =>
    (dynamicConfig && dynamicConfig.length)
        ? dynamicConfig.filter((config: DynamicConfig) => config.show || config.enabled)
            .map((config: DynamicConfig) => {
                const item = itemsConfig[config.key];
                return item ? {
                    ...item,
                    staticView: true,
                    defaultValue: item.defaultValue || defaultValues[config.key],
                    validators: dynamicValidators(config.required, item.validators, item.type),
                    disabled: !editable
                } : defaultHandler && defaultHandler(config, defaultValues[config.key], editable);
            })
            .filter((item: ItemConfig) => !!item)
        : [];
